import { AutoMap } from "@automapper/classes";
import { AreaMap } from "./area-map";
import { EDustLoadType } from "./enums/dust-load-type";
import { ESiteType } from "./enums/site-type";
import { ESubSection } from "./enums/subsection";
import { EVentilationGlobaleType } from "./enums/ventilation-global-type";
import { GlobalTask } from "./global-task";
import { MeanOfPrevention } from "./mean-of-prevention";
import { ProcessCalculation } from "./process-calculation";
import { ProcessMeasure } from "./process-mesure";
import { ProcessTechnique } from "./process-technique";


export class Process {
    @AutoMap()
    Code!: string;
    @AutoMap()
    Name!: string;
    @AutoMap()
    CustomerReference?: string;
    @AutoMap()
    Type!: ESiteType;
    @AutoMap()
    DustLevel!: string;
    @AutoMap()
    DustLoadType!: EDustLoadType;
    @AutoMap()
    SubSection!: ESubSection;
    @AutoMap()
    Observation?: string;
    @AutoMap()
    VolumeRenouvellementAir?: number;
    
    @AutoMap()
    VentilationGlobale!: EVentilationGlobaleType;
    @AutoMap()
    ProcessMesure: ProcessMeasure = new ProcessMeasure();
    @AutoMap(() => [ProcessTechnique])
    ProcessTechniqueList: ProcessTechnique[] = [];
    @AutoMap(() => [GlobalTask])
    TaskList: GlobalTask[] = [];
    @AutoMap()
    ProcessCalculation!: ProcessCalculation;
    @AutoMap(() => [MeanOfPrevention])
    EnvCollectiveMeansOfPreventionList: MeanOfPrevention[] = [];
    @AutoMap()
    AreaMap!: AreaMap;


    public constructor(init?: Partial<Process>) {
        Object.assign(this, init);
    }

    static mapFromJson(json: any) {
        const p = new Process;

        p.CustomerReference = json['customerReference'];

        p.Name = json['name'];

        p.DustLevel = json['dustLevel'];
        p.DustLoadType = json['dustLoadType'];
        // p.Type = json['type'];


        // if (json['processAreaMaps']) {
        //     p.AreaMaps = json['processAreaMaps'].map((jsonItem: any) => AreaMapDto.mapFromJson(jsonItem));
        // }

        // if (json['dustTypes']) {
        //     p.DustTypes = json['dustTypes'].map(jsonItem => String(jsonItem));
        // }
        // if (json['envCollectiveMeansOfPrevention']) {
        //     p.EnvCollectiveMeansOfPrevention = json['envCollectiveMeansOfPrevention'].map(jsonItem => String(jsonItem));
        // }

        // if (json['pTasks']) {
        //     p.TaskList = json['pTasks'].map(jsonItem => Task.mapFromJson(jsonItem));
        // }

        // if (json['samplingStrategies']) {
        //     p.SamplingStrategyList = json['samplingStrategies'].map(jsonItem => SamplingStrategy.mapFromJson(jsonItem));
        // }
        // if (json['analyticalStrategies']) {
        //     p.AnalyticalStrategyList = json['analyticalStrategies'].map(jsonItem => AnalyticalStrategy.mapFromJson(jsonItem));
        // }


        // if (json['tmin100FiberEC']) {
        //     p.Result.push(Result.mapFromJson(json));
        // }

        // if (json['processTechniques']) {
        //     p.ProcessTechniqueList = json['processTechniques'].map(jsonItem => ProcessTechnique.mapFromJson(jsonItem));
        // }

        return p;
    }
}
